export const VENTURES_RESET_STATE = 'VENTURES_RESET_STATE';
export const VENTURES_CURRENT_ITEM = 'VENTURES_CURRENT_ITEM';

export const VENTURES_REQUEST_LOADING = 'VENTURES_REQUEST_LOADING';
export const VENTURES_REQUEST_SUCCESS = 'VENTURES_REQUEST_SUCCESS';
export const VENTURES_REQUEST_FAILED = 'VENTURES_REQUEST_FAILED';

export const VENTURES_CURRENT_ACTION = 'VENTURES_CURRENT_ACTION';
export const VENTURES_RESET_ACTION = 'VENTURES_RESET_ACTION';